// export const countries = [
//     { label: 'Albania', value: 'AL' },
//     { label: 'Åland Islands', value: 'AX' },
//     { label: 'Algeria', value: 'DZ' },
//     { label: 'American Samoa', value: 'AS' },
//     { label: 'Andorra', value: 'AD' },
//     { label: 'Angola', value: 'AO' },
//     { label: 'Anguilla', value: 'AI' },
//     { label: 'Antarctica', value: 'AQ' },
//     { label: 'Antigua and Barbuda', value: 'AG' },
//     { label: 'Argentina', value: 'AR' },
//     { label: 'Armenia', value: 'AM' },
//     { label: 'Aruba', value: 'AW' },
//     { label: 'Australia', value: 'AU' },
//     { label: 'Austria', value: 'AT' },
//     { label: 'Azerbaijan', value: 'AZ' },
//     { label: 'Bahamas (the)', value: 'BS' },
//     { label: 'Bahrain', value: 'BH' },
//     { label: 'Bangladesh', value: 'BD' },
//     { label: 'Barbados', value: 'BB' },
//     { label: 'Belarus', value: 'BY' },
//     { label: 'Belgium', value: 'BE' },
//     { label: 'Belize', value: 'BZ' },
//     { label: 'Benin', value: 'BJ' },
//     { label: 'Bermuda', value: 'BM' },
//     { label: 'Bhutan', value: 'BT' },
//     { label: 'Bolivia (Plurinational State of)', value: 'BO' },
//     { label: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
//     { label: 'Bosnia and Herzegovina', value: 'BA' },
//     { label: 'Botswana', value: 'BW' },
//     { label: 'Bouvet Island', value: 'BV' },
//     { label: 'Brazil', value: 'BR' },
//     { label: 'British Indian Ocean Territory (the)', value: 'IO' },
//     { label: 'Brunei Darussalam', value: 'BN' },
//     { label: 'Bulgaria', value: 'BG' },
//     { label: 'Burkina Faso', value: 'BF' },
//     { label: 'Burundi', value: 'BI' },
//     { label: 'Cabo Verde', value: 'CV' },
//     { label: 'Cambodia', value: 'KH' },
//     { label: 'Cameroon', value: 'CM' },
//     { label: 'Canada', value: 'CA' },
//     { label: 'Cayman Islands (the)', value: 'KY' },
//     { label: 'Central African Republic (the)', value: 'CF' },
//     { label: 'Chad', value: 'TD' },
//     { label: 'Chile', value: 'CL' },
//     { label: 'China', value: 'CN' },
//     { label: 'Christmas Island', value: 'CX' },
//     { label: 'Cocos (Keeling) Islands (the)', value: 'CC' },
//     { label: 'Colombia', value: 'CO' },
//     { label: 'Comoros (the)', value: 'KM' },
//     { label: 'Congo (the Democratic Republic of the)', value: 'CD' },
//     { label: 'Congo (the)', value: 'CG' },
//     { label: 'Cook Islands (the)', value: 'CK' },
//     { label: 'Costa Rica', value: 'CR' },
//     { label: 'Croatia', value: 'HR' },
//     { label: 'Cuba', value: 'CU' },
//     { label: 'Curaçao', value: 'CW' },
//     { label: 'Cyprus', value: 'CY' },
//     { label: 'Czechia', value: 'CZ' },
//     { label: "Côte d'Ivoire", value: 'CI' },
//     { label: 'Denmark', value: 'DK' },
//     { label: 'Djibouti', value: 'DJ' },
//     { label: 'Dominica', value: 'DM' },
//     { label: 'Dominican Republic (the)', value: 'DO' },
//     { label: 'Ecuador', value: 'EC' },
//     { label: 'Egypt', value: 'EG' },
//     { label: 'El Salvador', value: 'SV' },
//     { label: 'Equatorial Guinea', value: 'GQ' },
//     { label: 'Eritrea', value: 'ER' },
//     { label: 'Estonia', value: 'EE' },
//     { label: 'Eswatini', value: 'SZ' },
//     { label: 'Ethiopia', value: 'ET' },
//     { label: 'Falkland Islands (the) [Malvinas]', value: 'FK' },
//     { label: 'Faroe Islands (the)', value: 'FO' },
//     { label: 'Fiji', value: 'FJ' },
//     { label: 'Finland', value: 'FI' },
//     { label: 'France', value: 'FR' },
//     { label: 'French Guiana', value: 'GF' },
//     { label: 'French Polynesia', value: 'PF' },
//     { label: 'French Southern Territories (the)', value: 'TF' },
//     { label: 'Gabon', value: 'GA' },
//     { label: 'Gambia (the)', value: 'GM' },
//     { label: 'Georgia', value: 'GE' },
//     { label: 'Germany', value: 'DE' },
//     { label: 'Ghana', value: 'GH' },
//     { label: 'Gibraltar', value: 'GI' },
//     { label: 'Greece', value: 'GR' },
//     { label: 'Greenland', value: 'GL' },
//     { label: 'Grenada', value: 'GD' },
//     { label: 'Guadeloupe', value: 'GP' },
//     { label: 'Guam', value: 'GU' },
//     { label: 'Guatemala', value: 'GT' },
//     { label: 'Guernsey', value: 'GG' },
//     { label: 'Guinea', value: 'GN' },
//     { label: 'Guinea-Bissau', value: 'GW' },
//     { label: 'Guyana', value: 'GY' },
//     { label: 'Haiti', value: 'HT' },
//     { label: 'Heard Island and McDonald Islands', value: 'HM' },
//     { label: 'Holy See (the)', value: 'VA' },
//     { label: 'Honduras', value: 'HN' },
//     { label: 'Hong Kong', value: 'HK' },
//     { label: 'Hungary', value: 'HU' },
//     { label: 'Iceland', value: 'IS' },
//     { label: 'India', value: 'IN' },
//     { label: 'Indonesia', value: 'ID' },
//     { label: 'Iran (Islamic Republic of)', value: 'IR' },
//     { label: 'Iraq', value: 'IQ' },
//     { label: 'Ireland', value: 'IE' },
//     { label: 'Isle of Man', value: 'IM' },
//     { label: 'Israel', value: 'IL' },
//     { label: 'Italy', value: 'IT' },
//     { label: 'Jamaica', value: 'JM' },
//     { label: 'Japan', value: 'JP' },
//     { label: 'Jersey', value: 'JE' },
//     { label: 'Jordan', value: 'JO' },
//     { label: 'Kazakhstan', value: 'KZ' },
//     { label: 'Kenya', value: 'KE' },
//     { label: 'Kiribati', value: 'KI' },
//     { label: "Korea (the Democratic People's Republic of)", value: 'KP' },
//     { label: 'Korea (the Republic of)', value: 'KR' },
//     { label: 'Kuwait', value: 'KW' },
//     { label: 'Kyrgyzstan', value: 'KG' },
//     { label: "Lao People's Democratic Republic (the)", value: 'LA' },
//     { label: 'Latvia', value: 'LV' },
//     { label: 'Lebanon', value: 'LB' },
//     { label: 'Lesotho', value: 'LS' },
//     { label: 'Liberia', value: 'LR' },
//     { label: 'Libya', value: 'LY' },
//     { label: 'Liechtenstein', value: 'LI' },
//     { label: 'Lithuania', value: 'LT' },
//     { label: 'Luxembourg', value: 'LU' },
//     { label: 'Macao', value: 'MO' },
//     { label: 'Madagascar', value: 'MG' },
//     { label: 'Malawi', value: 'MW' },
//     { label: 'Malaysia', value: 'MY' },
//     { label: 'Maldives', value: 'MV' },
//     { label: 'Mali', value: 'ML' },
//     { label: 'Malta', value: 'MT' },
//     { label: 'Marshall Islands (the)', value: 'MH' },
//     { label: 'Martinique', value: 'MQ' },
//     { label: 'Mauritania', value: 'MR' },
//     { label: 'Mauritius', value: 'MU' },
//     { label: 'Mayotte', value: 'YT' },
//     { label: 'Mexico', value: 'MX' },
//     { label: 'Micronesia (Federated States of)', value: 'FM' },
//     { label: 'Moldova (the Republic of)', value: 'MD' },
//     { label: 'Monaco', value: 'MC' },
//     { label: 'Mongolia', value: 'MN' },
//     { label: 'Montenegro', value: 'ME' },
//     { label: 'Montserrat', value: 'MS' },
//     { label: 'Morocco', value: 'MA' },
//     { label: 'Mozambique', value: 'MZ' },
//     { label: 'Myanmar', value: 'MM' },
//     { label: 'Namibia', value: 'NA' },
//     { label: 'Nauru', value: 'NR' },
//     { label: 'Nepal', value: 'NP' },
//     { label: 'Netherlands (the)', value: 'NL' },
//     { label: 'New Caledonia', value: 'NC' },
//     { label: 'New Zealand', value: 'NZ' },
//     { label: 'Nicaragua', value: 'NI' },
//     { label: 'Niger (the)', value: 'NE' },
//     { label: 'Nigeria', value: 'NG' },
//     { label: 'Niue', value: 'NU' },
//     { label: 'Norfolk Island', value: 'NF' },
//     { label: 'Northern Mariana Islands (the)', value: 'MP' },
//     { label: 'Norway', value: 'NO' },
//     { label: 'Oman', value: 'OM' },
//     { label: 'Pakistan', value: 'PK' },
//     { label: 'Palau', value: 'PW' },
//     { label: 'Palestine, State of', value: 'PS' },
//     { label: 'Panama', value: 'PA' },
//     { label: 'Papua New Guinea', value: 'PG' },
//     { label: 'Paraguay', value: 'PY' },
//     { label: 'Peru', value: 'PE' },
//     { label: 'Philippines (the)', value: 'PH' },
//     { label: 'Pitcairn', value: 'PN' },
//     { label: 'Poland', value: 'PL' },
//     { label: 'Portugal', value: 'PT' },
//     { label: 'Puerto Rico', value: 'PR' },
//     { label: 'Qatar', value: 'QA' },
//     { label: 'Republic of North Macedonia', value: 'MK' },
//     { label: 'Romania', value: 'RO' },
//     { label: 'Russian Federation (the)', value: 'RU' },
//     { label: 'Rwanda', value: 'RW' },
//     { label: 'Réunion', value: 'RE' },
//     { label: 'Saint Barthélemy', value: 'BL' },
//     { label: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH' },
//     { label: 'Saint Kitts and Nevis', value: 'KN' },
//     { label: 'Saint Lucia', value: 'LC' },
//     { label: 'Saint Martin (French part)', value: 'MF' },
//     { label: 'Saint Pierre and Miquelon', value: 'PM' },
//     { label: 'Saint Vincent and the Grenadines', value: 'VC' },
//     { label: 'Samoa', value: 'WS' },
//     { label: 'San Marino', value: 'SM' },
//     { label: 'Sao Tome and Principe', value: 'ST' },
//     { label: 'Saudi Arabia', value: 'SA' },
//     { label: 'Senegal', value: 'SN' },
//     { label: 'Serbia', value: 'RS' },
//     { label: 'Seychelles', value: 'SC' },
//     { label: 'Sierra Leone', value: 'SL' },
//     { label: 'Singapore', value: 'SG' },
//     { label: 'Sint Maarten (Dutch part)', value: 'SX' },
//     { label: 'Slovakia', value: 'SK' },
//     { label: 'Slovenia', value: 'SI' },
//     { label: 'Solomon Islands', value: 'SB' },
//     { label: 'Somalia', value: 'SO' },
//     { label: 'South Africa', value: 'ZA' },
//     { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
//     { label: 'South Sudan', value: 'SS' },
//     { label: 'Spain', value: 'ES' },
//     { label: 'Sri Lanka', value: 'LK' },
//     { label: 'Sudan (the)', value: 'SD' },
//     { label: 'Surilabel', value: 'SR' },
//     { label: 'Svalbard and Jan Mayen', value: 'SJ' },
//     { label: 'Sweden', value: 'SE' },
//     { label: 'Switzerland', value: 'CH' },
//     { label: 'Syrian Arab Republic', value: 'SY' },
//     { label: 'Taiwan (Province of China)', value: 'TW' },
//     { label: 'Tajikistan', value: 'TJ' },
//     { label: 'Tanzania, United Republic of', value: 'TZ' },
//     { label: 'Thailand', value: 'TH' },
//     { label: 'Timor-Leste', value: 'TL' },
//     { label: 'Togo', value: 'TG' },
//     { label: 'Tokelau', value: 'TK' },
//     { label: 'Tonga', value: 'TO' },
//     { label: 'Trinidad and Tobago', value: 'TT' },
//     { label: 'Tunisia', value: 'TN' },
//     { label: 'Turkey', value: 'TR' },
//     { label: 'Turkmenistan', value: 'TM' },
//     { label: 'Turks and Caicos Islands (the)', value: 'TC' },
//     { label: 'Tuvalu', value: 'TV' },
//     { label: 'Uganda', value: 'UG' },
//     { label: 'Ukraine', value: 'UA' },
//     { label: 'United Arab Emirates (the)', value: 'AE' },
//     {
//         label: 'United Kingdom of Great Britain and Northern Ireland (the)',
//         value: 'GB',
//     },
//     { label: 'United States Minor Outlying Islands (the)', value: 'UM' },
//     { label: 'United States of America (the)', value: 'US' },
//     { label: 'Uruguay', value: 'UY' },
//     { label: 'Uzbekistan', value: 'UZ' },
//     { label: 'Vanuatu', value: 'VU' },
//     { label: 'Venezuela (Bolivarian Republic of)', value: 'VE' },
//     { label: 'Viet Nam', value: 'VN' },
//     { label: 'Virgin Islands (British)', value: 'VG' },
//     { label: 'Virgin Islands (U.S.)', value: 'VI' },
//     { label: 'Wallis and Futuna', value: 'WF' },
//     { label: 'Western Sahara', value: 'EH' },
//     { label: 'Yemen', value: 'YE' },
//     { label: 'Zambia', value: 'ZM' },
//     { label: 'Zimbabwe', value: 'ZW' },
// ];

export const countries = [
  { label: "Afghanistan", value: "Afghanistan" },
  { label: "Åland Islands", value: "Åland Islands" },
  { label: "Albania", value: "Albania" },
  { label: "Algeria", value: "Algeria" },
  { label: "American Samoa", value: "American Samoa" },
  { label: "Andorra", value: "Andorra" },
  { label: "Angola", value: "Angola" },
  { label: "Anguilla", value: "Anguilla" },
  { label: "Antarctica", value: "Antarctica" },
  { label: "Antigua and Barbuda", value: "Antigua and Barbuda" },
  { label: "Argentina", value: "Argentina" },
  { label: "Armenia", value: "Armenia" },
  { label: "Aruba", value: "Aruba" },
  { label: "Australia", value: "Australia" },
  { label: "Austria", value: "Austria" },
  { label: "Azerbaijan", value: "Azerbaijan" },
  { label: "Bahamas", value: "Bahamas" },
  { label: "Bahrain", value: "Bahrain" },
  { label: "Bangladesh", value: "Bangladesh" },
  { label: "Barbados", value: "Barbados" },
  { label: "Belarus", value: "Belarus" },
  { label: "Belgium", value: "Belgium" },
  { label: "Belize", value: "Belize" },
  { label: "Benin", value: "Benin" },
  { label: "Bermuda", value: "Bermuda" },
  { label: "Bhutan", value: "Bhutan" },
  { label: "Bolivia", value: "Bolivia" },
  { label: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
  { label: "Botswana", value: "Botswana" },
  { label: "Bouvet Island", value: "Bouvet Island" },
  { label: "Brazil", value: "Brazil" },
  {
    label: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
  },
  { label: "Brunei Darussalam", value: "Brunei Darussalam" },
  { label: "Bulgaria", value: "Bulgaria" },
  { label: "Burkina Faso", value: "Burkina Faso" },
  { label: "Burundi", value: "Burundi" },
  { label: "Cambodia", value: "Cambodia" },
  { label: "Cameroon", value: "Cameroon" },
  { label: "Canada", value: "Canada" },
  { label: "Cape Verde", value: "Cape Verde" },
  { label: "Cayman Islands", value: "Cayman Islands" },
  { label: "Central African Republic", value: "Central African Republic" },
  { label: "Chad", value: "Chad" },
  { label: "Chile", value: "Chile" },
  { label: "China", value: "China" },
  { label: "Christmas Island", value: "Christmas Island" },
  { label: "Cocos (Keeling) Islands", value: "Cocos (Keeling) Islands" },
  { label: "Colombia", value: "Colombia" },
  { label: "Comoros", value: "Comoros" },
  { label: "Congo", value: "Congo" },
  {
    label: "Congo, The Democratic Republic of the",
    value: "Congo, The Democratic Republic of the",
  },
  { label: "Cook Islands", value: "Cook Islands" },
  { label: "Costa Rica", value: "Costa Rica" },
  { label: "Croatia", value: "Croatia" },
  { label: "Cuba", value: "Cuba" },
  { label: "Cyprus", value: "Cyprus" },
  { label: "Czech Republic", value: "Czech Republic" },
  { label: "Denmark", value: "Denmark" },
  { label: "Djibouti", value: "Djibouti" },
  { label: "Dominica", value: "Dominica" },
  { label: "Dominican Republic", value: "Dominican Republic" },
  { label: "Ecuador", value: "Ecuador" },
  { label: "Egypt", value: "Egypt" },
  { label: "El Salvador", value: "El Salvador" },
  { label: "Equatorial Guinea", value: "Equatorial Guinea" },
  { label: "Eritrea", value: "Eritrea" },
  { label: "Estonia", value: "Estonia" },
  { label: "Ethiopia", value: "Ethiopia" },
  {
    label: "Falkland Islands (Malvinas)",
    value: "Falkland Islands (Malvinas)",
  },
  { label: "Faroe Islands", value: "Faroe Islands" },
  { label: "Fiji", value: "Fiji" },
  { label: "Finland", value: "Finland" },
  { label: "France", value: "France" },
  { label: "French Guiana", value: "French Guiana" },
  { label: "French Polynesia", value: "French Polynesia" },
  {
    label: "French Southern Territories",
    value: "French Southern Territories",
  },
  { label: "Gabon", value: "Gabon" },
  { label: "Gambia", value: "Gambia" },
  { label: "Georgia", value: "Georgia" },
  { label: "Germany", value: "Germany" },
  { label: "Ghana", value: "Ghana" },
  { label: "Gibraltar", value: "Gibraltar" },
  { label: "Greece", value: "Greece" },
  { label: "Greenland", value: "Greenland" },
  { label: "Grenada", value: "Grenada" },
  { label: "Guadeloupe", value: "Guadeloupe" },
  { label: "Guam", value: "Guam" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "Guernsey", value: "Guernsey" },
  { label: "Guinea", value: "Guinea" },
  { label: "Guinea-Bissau", value: "Guinea-Bissau" },
  { label: "Guyana", value: "Guyana" },
  { label: "Haiti", value: "Haiti" },
  {
    label: "Heard Island and Mcdonald Islands",
    value: "Heard Island and Mcdonald Islands",
  },
  {
    label: "Holy See (Vatican City State)",
    value: "Holy See (Vatican City State)",
  },
  { label: "Honduras", value: "Honduras" },
  { label: "Hong Kong", value: "Hong Kong" },
  { label: "Hungary", value: "Hungary" },
  { label: "Iceland", value: "Iceland" },
  { label: "India", value: "India" },
  { label: "Indonesia", value: "Indonesia" },
  { label: "Iran, Islamic Republic Of", value: "Iran, Islamic Republic Of" },
  { label: "Iraq", value: "Iraq" },
  { label: "Ireland", value: "Ireland" },
  { label: "Isle of Man", value: "Isle of Man" },
  { label: "Israel", value: "Israel" },
  { label: "Italy", value: "Italy" },
  { label: "Jamaica", value: "Jamaica" },
  { label: "Japan", value: "Japan" },
  { label: "Jersey", value: "Jersey" },
  { label: "Jordan", value: "Jordan" },
  { label: "Kazakhstan", value: "Kazakhstan" },
  { label: "Kenya", value: "Kenya" },
  { label: "Kiribati", value: "Kiribati" },
  {
    label: "Korea, Democratic People'S Republic of",
    value: "Korea, Democratic People'S Republic of",
  },
  { label: "Korea, Republic of", value: "Korea, Republic of" },
  { label: "Kuwait", value: "Kuwait" },
  { label: "Kyrgyzstan", value: "Kyrgyzstan" },
  {
    label: "Lao People'S Democratic Republic",
    value: "Lao People'S Democratic Republic",
  },
  { label: "Latvia", value: "Latvia" },
  { label: "Lebanon", value: "Lebanon" },
  { label: "Lesotho", value: "Lesotho" },
  { label: "Liberia", value: "Liberia" },
  { label: "Libyan Arab Jamahiriya", value: "Libyan Arab Jamahiriya" },
  { label: "Liechtenstein", value: "Liechtenstein" },
  { label: "Lithuania", value: "Lithuania" },
  { label: "Luxembourg", value: "Luxembourg" },
  { label: "Macao", value: "Macao" },
  {
    label: "Macedonia, The Former Yugoslav Republic of",
    value: "Macedonia, The Former Yugoslav Republic of",
  },
  { label: "Madagascar", value: "Madagascar" },
  { label: "Malawi", value: "Malawi" },
  { label: "Malaysia", value: "Malaysia" },
  { label: "Maldives", value: "Maldives" },
  { label: "Mali", value: "Mali" },
  { label: "Malta", value: "Malta" },
  { label: "Marshall Islands", value: "Marshall Islands" },
  { label: "Martinique", value: "Martinique" },
  { label: "Mauritania", value: "Mauritania" },
  { label: "Mauritius", value: "Mauritius" },
  { label: "Mayotte", value: "Mayotte" },
  { label: "Mexico", value: "Mexico" },
  {
    label: "Micronesia, Federated States of",
    value: "Micronesia, Federated States of",
  },
  { label: "Moldova, Republic of", value: "Moldova, Republic of" },
  { label: "Monaco", value: "Monaco" },
  { label: "Mongolia", value: "Mongolia" },
  { label: "Montenegro", value: "Montenegro" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Morocco", value: "Morocco" },
  { label: "Mozambique", value: "Mozambique" },
  { label: "Myanmar", value: "Myanmar" },
  { label: "Namibia", value: "Namibia" },
  { label: "Nauru", value: "Nauru" },
  { label: "Nepal", value: "Nepal" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "New Caledonia", value: "New Caledonia" },
  { label: "New Zealand", value: "New Zealand" },
  { label: "Nicaragua", value: "Nicaragua" },
  { label: "Niger", value: "Niger" },
  { label: "Nigeria", value: "Nigeria" },
  { label: "Niue", value: "Niue" },
  { label: "Norfolk Island", value: "Norfolk Island" },
  { label: "Northern Mariana Islands", value: "Northern Mariana Islands" },
  { label: "Norway", value: "Norway" },
  { label: "Oman", value: "Oman" },
  { label: "Pakistan", value: "Pakistan" },
  { label: "Palau", value: "Palau" },
  {
    label: "Palestinian Territory, Occupied",
    value: "Palestinian Territory, Occupied",
  },
  { label: "Panama", value: "Panama" },
  { label: "Papua New Guinea", value: "Papua New Guinea" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Peru", value: "Peru" },
  { label: "Philippines", value: "Philippines" },
  { label: "Pitcairn", value: "Pitcairn" },
  { label: "Poland", value: "Poland" },
  { label: "Portugal", value: "Portugal" },
  { label: "Puerto Rico", value: "Puerto Rico" },
  { label: "Qatar", value: "Qatar" },
  { label: "Réunion", value: "Réunion" },
  { label: "Romania", value: "Romania" },
  { label: "Russian Federation", value: "Russian Federation" },
  { label: "Rwanda", value: "Rwanda" },
  { label: "Saint Barthélemy", value: "Saint Barthélemy" },
  {
    label: "Saint Helena, Ascension and Tristan Da Cunha",
    value: "Saint Helena, Ascension and Tristan Da Cunha",
  },
  { label: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
  { label: "Saint Lucia", value: "Saint Lucia" },
  { label: "Saint Martin (French part)", value: "Saint Martin (French part)" },
  { label: "Saint Pierre and Miquelon", value: "Saint Pierre and Miquelon" },
  {
    label: "Saint Vincent and The Grenadines",
    value: "Saint Vincent and The Grenadines",
  },
  { label: "Samoa", value: "Samoa" },
  { label: "San Marino", value: "San Marino" },
  { label: "Sao Tome and Principe", value: "Sao Tome and Principe" },
  { label: "Saudi Arabia", value: "Saudi Arabia" },
  { label: "Senegal", value: "Senegal" },
  { label: "Serbia", value: "Serbia" },
  { label: "Seychelles", value: "Seychelles" },
  { label: "Sierra Leone", value: "Sierra Leone" },
  { label: "Singapore", value: "Singapore" },
  { label: "Sint Maarten (Dutch part)", value: "Sint Maarten (Dutch part)" },
  { label: "Slovakia", value: "Slovakia" },
  { label: "Slovenia", value: "Slovenia" },
  { label: "Solomon Islands", value: "Solomon Islands" },
  { label: "Somalia", value: "Somalia" },
  { label: "South Africa", value: "South Africa" },
  {
    label: "South Georgia and The South Sandwich Islands",
    value: "South Georgia and The South Sandwich Islands",
  },
  { label: "Spain", value: "Spain" },
  { label: "Sri Lanka", value: "Sri Lanka" },
  { label: "Sudan", value: "Sudan" },
  { label: "Suriname", value: "Suriname" },
  { label: "Svalbard and Jan Mayen", value: "Svalbard and Jan Mayen" },
  { label: "Swaziland", value: "Swaziland" },
  { label: "Sweden", value: "Sweden" },
  { label: "Switzerland", value: "Switzerland" },
  { label: "Syrian Arab Republic", value: "Syrian Arab Republic" },
  { label: "Taiwan, Province of China", value: "Taiwan, Province of China" },
  { label: "Tajikistan", value: "Tajikistan" },
  {
    label: "Tanzania, United Republic of",
    value: "Tanzania, United Republic of",
  },
  { label: "Thailand", value: "Thailand" },
  { label: "Timor-Leste", value: "Timor-Leste" },
  { label: "Togo", value: "Togo" },
  { label: "Tokelau", value: "Tokelau" },
  { label: "Tonga", value: "Tonga" },
  { label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
  { label: "Tunisia", value: "Tunisia" },
  { label: "Turkey", value: "Turkey" },
  { label: "Turkmenistan", value: "Turkmenistan" },
  { label: "Turks and Caicos Islands", value: "Turks and Caicos Islands" },
  { label: "Tuvalu", value: "Tuvalu" },
  { label: "Uganda", value: "Uganda" },
  { label: "Ukraine", value: "Ukraine" },
  { label: "United Arab Emirates", value: "United Arab Emirates" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "United States", value: "United States" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Uzbekistan", value: "Uzbekistan" },
  { label: "Vanuatu", value: "Vanuatu" },
  { label: "Venezuela", value: "Venezuela" },
  { label: "Viet Nam", value: "Viet Nam" },
  { label: "Western Sahara", value: "Western Sahara" },
  { label: "Yemen", value: "Yemen" },
  { label: "Zambia", value: "Zambia" },
  { label: "Zimbabwe", value: "Zimbabwe" },
];
